import React, {useState, useEffect} from 'react';
import Chart from 'react-apexcharts';
import Title from '../../../../components/Title';
import Carousel from 'react-multi-carousel';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import 'react-multi-carousel/lib/styles.css';
import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import DrawTable from '../../../../components/DrawTable';
import DataCard from '../DataCard';
import {
  AnnotationsMonth,
  AnnotationsPremiums,
  getMonthName,
  getPlanName,
  months,
  premiuns,
  responsive,
  responsiveCards,
  responsiveMedium,
  returnTotalValues,
  returnTotalValuesPremium,
  returnValuesPremium,
  returnValuesTotalPremium,
} from '../../service/utils';
import dashboardService from '../../service';
import {KeyboardDatePicker} from '@material-ui/pickers';
import DrawTableDash from '../../../../components/DrawTableDash';
import {GetAppOutlined} from '@material-ui/icons';
import {styles} from './styles';
import api from '../../../../core/api';
import {CustomSelect} from './components/CustomSelect';
import {MetricCell} from './components/MetricCell';

const TopContentItem = () => {
  const colorMap = {
    Meditações: '#8B5CF6',
    Conexão: '#06B6D4',
    Yoga: '#8B5CF6',
    Fé: '#F59E0B',
    Músicas: '#EC4899',
    Exercícios: '#6366F1',
  };
  const [loadingScreen, setLoadingScreen] = useState(false);
  const [chartNames, setChartNames] = useState([]);
  const [chartValues, setChartValues] = useState([]);

  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [topContents, setTopContentData] = useState([]);
  const [filters, setFilters] = useState({
    platform: null,
    currentAccountType: null,
  });

  const [limit, setLimit] = useState(20);
  const [showAll, setShowAll] = useState(false);

  const GetData = async () => {
    setLoading(true);

    const response = await dashboardService.getTopContents({
      startDate,
      endDate,
      filters: {
        limit,
        showAll,
        platform: filters.platform || null,
        currentAccountType: filters.currentAccountType || null,
      },
    });
    setTopContentData(response.data || []);

    setLoading(false);
  };

  useEffect(() => {
    GetData();
  }, [startDate, endDate, filters, limit, showAll]);

  return (
    <div
      style={{
        margin: 15,
        marginTop: 25,
        padding: 20,
        backgroundColor: '#fff',
        borderRadius: 10,
      }}>
      <div>
        <Typography
          component="h1"
          variant="h6"
          color="inherit"
          noWrap
          style={{marginBottom: 20}}>
          {showAll ? 'Todos os Conteúdos' : `Top ${limit} Conteúdos`}
        </Typography>

        <div style={styles.flex}>
          <CustomSelect
            title="Plataforma"
            values={[
              {value: null, label: 'Todos'},
              {value: 'android', label: 'Android'},
              {value: 'ios', label: 'IOS'},
            ]}
            value={filters.platform}
            setValue={event =>
              setFilters({
                ...filters,
                platform: event,
              })
            }
          />

          <CustomSelect
            title="Assinantes"
            values={[
              {value: null, label: 'Todos'},
              {value: 'subscriber', label: 'Sim'},
              {value: 'free', label: 'Não'},
            ]}
            value={filters.currentAccountType}
            setValue={event =>
              setFilters({
                ...filters,
                currentAccountType: event,
              })
            }
          />

          <div style={styles.flexEnd}>
            <div style={styles.datePicker}>
              <KeyboardDatePicker
                value={startDate}
                format="DD/MM/YYYY"
                maxDate={endDate}
                onChange={date => {
                  const newDate = new Date(date);

                  if (newDate > endDate) {
                    setEndDate(newDate);
                  }

                  setStartDate(newDate);
                }}
              />
            </div>

            <div style={styles.datePicker}>
              <KeyboardDatePicker
                value={endDate}
                format="DD/MM/YYYY"
                minDate={startDate}
                onChange={date => {
                  const newDate = new Date(date);

                  if (newDate < startDate) {
                    setStartDate(newDate);
                  }

                  setEndDate(newDate);
                }}
              />
            </div>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            gap: 10,
            marginTop: 15,
            marginBottom: 15,
            flexWrap: 'wrap',
          }}>
          <Button
            variant={!showAll && limit === 20 ? 'contained' : 'outlined'}
            color={!showAll && limit === 20 ? 'primary' : 'default'}
            onClick={() => {
              setShowAll(false);
              setLimit(20);
            }}>
            Top 20
          </Button>

          <Button
            variant={!showAll && limit > 20 ? 'contained' : 'outlined'}
            color={!showAll && limit > 20 ? 'primary' : 'default'}
            onClick={() => {
              setShowAll(false);
              setLimit(prev => prev + 20);
            }}>
            Mostrar mais ({limit})
          </Button>

          <Button
            variant={showAll ? 'contained' : 'outlined'}
            color={showAll ? 'primary' : 'default'}
            onClick={() => {
              setShowAll(true);
            }}>
            Mostrar todos
          </Button>

          <ReactHTMLTableToExcel
            id="export-xls-button"
            className={`MuiButtonBase-root MuiButton-root ${
              showAll ? 'MuiButton-contained' : 'MuiButton-outlined'
            } MuiButton-containedPrimary`}
            table="top-content-table"
            filename={`top-conteudos-${new Date().getTime()}`}
            sheet="conteudos"
            buttonText="Exportar Excel"
          />
        </div>

        <div
          style={{
            marginBottom: 15,
            display: 'flex',
          }}></div>
      </div>
      {loading ? (
        <div className="flex-col center-a center-b">
          <CircularProgress size={100} />
        </div>
      ) : (
        <Table id="top-content-table" style={{width: '100%'}}>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Nome</TableCell>
              <TableCell>Acessos</TableCell>
              <TableCell>Salvos</TableCell>
              <TableCell>Playlist</TableCell>
              <TableCell>Categoria</TableCell>
              <TableCell>Subcategoria</TableCell>
              <TableCell>Tipo</TableCell>
              <TableCell>Autor</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {topContents.length === 0 ? (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  <Typography variant="body2" color="textSecondary">
                    Nenhum Conteúdo encontrado
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              topContents.map((item, index) => (
                <TableRow
                  key={item.id}
                  style={{
                    opacity: item.access === 0 ? 0.6 : 1,
                  }}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    {item.name}

                    {item.access === 0 && (
                      <span
                        style={{
                          marginLeft: 8,
                          fontSize: 11,
                          color: '#9ca3af',
                        }}>
                        Sem visualizações
                      </span>
                    )}
                  </TableCell>
                  <TableCell>
                    <MetricCell
                      value={item.access}
                      percent={item.accessPerc}
                      color="#7C3AED"
                    />
                  </TableCell>

                  <TableCell>{item.saved}</TableCell>
                  <TableCell>{item.playlist}</TableCell>
                  <TableCell>{item.category}</TableCell>
                  <TableCell>{item.subcategory}</TableCell>
                  <TableCell>{item.type}</TableCell>
                  <TableCell>{item.author}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default TopContentItem;
